import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import FilterNumberInput from '../form/filters/FilterNumberInput';
import FilterCheckBox from './FilterCheckBox';
import { FilterToggle } from '.';
import styles from './search-filter.module.sass';

interface Props {
  businessesFilter: any;
  setBusinessesFilter: (any) => void;
  // setShouldUpdate: (boolean) => void;
}

const SearchFilter = ({
  businessesFilter,
  setBusinessesFilter,
}: // setShouldUpdate,
Props) => {
  const SearchFilterFormSchema = Yup.object().shape({
    locations: Yup.string().min(3, 'Too Short!').max(300, 'Too Long!'),
    ethicallySustainable: Yup.boolean(),
    hasFactor: Yup.boolean(),
    blackOwned: Yup.boolean(),
    blackFounded: Yup.boolean(),
    blackPartners: Yup.boolean(),
    blackFronted: Yup.boolean(),
    hasCredit: Yup.boolean(),
    hasInvestors: Yup.boolean(),
    wantsInvestorsFunding: Yup.boolean(),
    revenue: Yup.object().shape({
      min: Yup.number().positive('must be a positive number'),
      max: Yup.number().positive('must be a positive number'),
    }),
  });

  const [productionOpen, setProductionOpen] = useState(true);
  const [financesOpen, setFinancesOpen] = useState(true);
  const [revenueOpen, setRevenueOpen] = useState(true);

  return (
    <div className={`full-width column start ${styles.filter}`}>
      <Formik
        initialValues={{
          locations: '',
          // ethicallySustainable: businessesFilter.ethicallySustainable,
          hasFactor: businessesFilter.hasFactor,
          blackOwned: businessesFilter.blackOwned,
          blackFounded: businessesFilter.blackFounded,
          // blackPartners: businessesFilter.blackPartners,
          blackFronted: businessesFilter.blackFronted,
          hasCredit: businessesFilter.hasCredit,
          // hasInvestors: businessesFilter.hasInvestors,
          wantsInvestorsFunding: businessesFilter.wantsInvestorsFunding,
          // revenue: businessesFilter.revenue,
        }}
        validationSchema={SearchFilterFormSchema}
        onSubmit={(values: any) => {
          // setShouldUpdate(true);

          const newFilters = JSON.parse(JSON.stringify(values));
          const locationArray = newFilters['locations'].split(',');
          const newLocations = locationArray.map((item) => ({
            country: item,
          }));

          newFilters.locations = newLocations;
          // values.locations = newLocations;
          // console.log(JSON.stringify(values, null, 2));
          console.log(newFilters);
          setBusinessesFilter(newFilters);
        }}
      >
        {({ values }) => (
          <Form className={`column start ${styles.form}`}>
            {/* <div className={`full-width column start ${styles.container}`}>
              <label className={styles.label}>Location</label>
              <Field
                id="locations"
                name="locations"
                placeholder="Filter on location..."
                component={FilterTextInput}
              />
              <ErrorMessage
                name="locations"
                render={(msg) => <ErrorMessageComponent error={msg} />}
              />
            </div> */}

            <div className={styles.container}>
              <FilterToggle
                label="Production"
                onSelected={() => {
                  setProductionOpen(!productionOpen);
                }}
                selected={productionOpen}
              />
              {productionOpen && (
                <>
                  {/*<FilterCheckBox*/}
                  {/*  name="ethicallySustainable"*/}
                  {/*  label="SUSTAINABLE / ETHICALLY MADE"*/}
                  {/*  selected={values.ethicallySustainable ? true : false}*/}
                  {/*/>*/}
                  <FilterCheckBox
                    name="hasFactor"
                    label="WORK WITH A FACTORY"
                    selected={values.hasFactor ? true : false}
                  />
                </>
              )}
            </div>
            <div className={styles.container}>
              <FilterToggle
                label="Finances"
                onSelected={() => {
                  setFinancesOpen(!financesOpen);
                }}
                selected={financesOpen}
              />
              {financesOpen && (
                <>
                  {/*<FilterCheckBox*/}
                  {/*  name="hasCredit"*/}
                  {/*  label="ACCESS TO LINE OF CREDIT"*/}
                  {/*  selected={values.hasCredit ? true : false}*/}
                  {/*/>*/}
                  {/*<FilterCheckBox*/}
                  {/*  name="hasInvestors"*/}
                  {/*  label="HAS INVESTORS"*/}
                  {/*  selected={values.hasInvestors ? true : false}*/}
                  {/*/>*/}
                  <FilterCheckBox
                    name="wantsInvestorsFunding"
                    label="LOOKING FOR INVESTORS"
                    selected={values.wantsInvestorsFunding ? true : false}
                  />
                </>
              )}
            </div>
            {/*<div className={styles.container}>*/}
            {/*  <FilterToggle*/}
            {/*    label="Revenue"*/}
            {/*    onSelected={() => {*/}
            {/*      setRevenueOpen(!revenueOpen);*/}
            {/*    }}*/}
            {/*    selected={revenueOpen}*/}
            {/*  />*/}
            {/*  {revenueOpen && (*/}
            {/*    <>*/}
            {/*      <div className={`full-width row ${styles.revenue}`}>*/}
            {/*        <span className={styles.label}>$</span>*/}
            {/*        <Field*/}
            {/*          id="revenue.min"*/}
            {/*          name="revenue.min"*/}
            {/*          component={FilterNumberInput}*/}
            {/*          placeholder="min"*/}
            {/*          className={styles['min-max']}*/}
            {/*        />*/}
            {/*        <span className={styles.label}>-</span>*/}
            {/*        <span className={styles.label}>$</span>*/}
            {/*        <Field*/}
            {/*          id="revenue.max"*/}
            {/*          name="revenue.max"*/}
            {/*          component={FilterNumberInput}*/}
            {/*          placeholder="max"*/}
            {/*          className={styles['min-max']}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*    </>*/}
            {/*  )}*/}
            {/*</div>*/}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SearchFilter;

/* <div className={`full-width column start ${styles.container}`}>
      <label className={styles.label}>Ownership</label>
      <FormCheckBox
        name="blackOwned"
        label="BLACK OWNED"
        selected={values.blackOwned ? true : false}
      />
      <FormCheckBox
        name="blackFounded"
        label="BLACK FOUNDED"
        selected={values.blackFounded ? true : false}
      />
      <FormCheckBox
        name="blackPartners"
        label="BLACK PARTNERS"
        selected={values.blackPartners ? true : false}
      />
      <FormCheckBox
        name="blackFronted"
        label="BLACK FRONTED"
        selected={values.blackFronted ? true : false}
      />
    </div> */
